import wizardData from '@/app/[locale]/product/_steps/wizardData';
import { RingFinishEnum } from '@/app/enums/RingFinishEnum';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { ChargerModel } from '@/app/types/accessory';
import type { RingFinish, RingStyle } from '@/app/types/ring';

import type { ChargersStepData, RingsStepData } from '../wizardData/types';

interface GetWizardData {
  accessory: ChargerModel | '';
  style?: RingStyle | '';
  finish?: RingFinish | '';
}

const getWizardData = ({
  accessory = '',
  style = '',
  finish = '',
}: GetWizardData): ChargersStepData | RingsStepData | null => {
  if (accessory) {
    return wizardData[accessory];
  }
  const _style =
    style.length === 0 ? RingStyleEnum.OuraRing4 : (style as RingStyle);
  const _finish =
    finish.length === 0 ? RingFinishEnum.Silver : (finish as RingFinish);

  return wizardData[_style][_finish];
};

export default getWizardData;
